/* eslint-disable max-len */
import { Button, Grid, Stack, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { IoIosAdd } from 'react-icons/io';
import { WebinarContext } from '../../..';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../../../../../libs/Context';
import { catchErr } from '../../../../../../../libs/HelperContent';
import { createPoll, updatePolling } from '../../../../../../actions/meeting_actions';
import QuestionBox from './QuestionBox';
import { toast } from 'react-toastify';

const CreatePoll = (props) =>
{
	const { status, editPoll, handleClose, handlePollCreate } = props;
	const initialState = [ { question: '', questionType: 'single', options: [ '' ] } ];
	const [ questions, setQuestions ] = useState(status === 'edit' ? [ editPoll ] : initialState);
	const [ errorObj, setErrorObj ] = useState({});
	const [ loading, setLoading ] = useState<boolean>(false);
	const { language } = useContext(LanguageContext);
	const { form } = useContext(WebinarContext);

	const handleAddQuestion = () =>
	{
		setQuestions([ ...questions, { question: '', questionType: 'single', options: [ '' ] } ]);
	};

	const validation = (data) =>
	{
		const validateObj:any = {};

		data.forEach((item, index) =>
		{
			if (!item.question)
			{
				validateObj[index] = { ...validateObj[index], questionErrMsg: 'Please Enter the Question' };
			}

			if (item.options[0] === '')
			{
				validateObj[index] = { ...validateObj[index], OptionErrMsg: 'Please Enter the Option' };
			}
		});

		return validateObj;
	};
	const scrollToError = (errObj) =>
	{
		const elem = document.getElementById(`questionNumb_${Object.keys(errObj)[0]}`);

		if (elem)
		{
			elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	};
	const createPollBody = () =>
	{
		const body:any = { sessionId: form?.id };

		if (status === 'edit')
		{
			body.pollingId = editPoll?._id;
			body.question = questions[0]?.question;
			body.options = questions[0]?.options;
			body.questionType = questions[0]?.questionType;
		}
		else
		{
			body.polls = questions.map((item) => ({
				...item,
				options : item?.options?.filter((option) => option !== '')
			}));
		}

		return body;
	};

	const handelPollSubmit = async () =>
	{
		const errObj = validation(questions);

		setErrorObj(errObj);

		if (Object.keys(errObj).length > 0)
		{
			scrollToError(errObj);

			return;
		}

		if (Object.keys(errObj)?.length <= 0)
		{
			setLoading(true);

			const body = createPollBody();

			try
			{
				const res = status === 'create' ? await createPoll(body) : await updatePolling(body);

				if (res?.status)
				{
					setLoading(false);
					handlePollCreate(res?.data, status === 'create' ? 'create' : 'edit');
					toast.success(status === 'create' ? language?.pollCreate : language?.pollUpdate);
				}
				else
				{
					setLoading(false);
				}
			}
			catch (err)
			{
				setLoading(false);
				catchErr(err);
			}
		}
	};

	const handleValidation = () =>
	{
		const isAnyFieldEmpty = questions.some((ques) =>
		{
			const isAnyOptionEmpty = ques.options.some((opt) => opt.trim() === '');

			return isAnyOptionEmpty || ques.question.trim() === '';
		});

		const hasAnyError =	Object.values(errorObj)?.some((err) => err && Object.keys(err).length > 0);

		if (status === 'edit')
		{
			const isQuestionSame = editPoll?.question === questions[0]?.question;
			// eslint-disable-next-line max-len
			const areOptionSame = JSON.stringify(editPoll?.options) === JSON.stringify(questions[0]?.options);
			const isSwitchSame = editPoll?.questionType === questions[0]?.questionType;

			return isAnyFieldEmpty || (isQuestionSame && areOptionSame && isSwitchSame);
		}
		else return isAnyFieldEmpty || hasAnyError;
	};

	const isDisabled = handleValidation();

	return (
		<Grid item xs={12}>
			{loading && <Loading />}
			<Typography>{language?.questions} ({questions.length}) </Typography>
			<Grid container flexDirection={'column'} xs={12}>
				<Stack direction='column' sx={{ maxHeight: '400px', overflowY: 'auto' }}>
					{questions?.length > 0 && questions?.map((q, qIndex) => (
						<QuestionBox
							showDelete={questions?.length > 1}
							key={qIndex}
							q={q} qIndex={qIndex} errorObj={errorObj} questions={questions}
							setQuestions={setQuestions} status={status}
						/>
					))}
				</Stack>
				{status === 'create' &&
				<Button disabled={isDisabled} variant='outlined' sx={{ textTransform: 'capitalize' }} startIcon={<IoIosAdd />} onClick={handleAddQuestion}>
					{language?.AddQues}
				</Button>}
			</Grid>
			<Stack direction='row' p='var(--pixel16)' justifyContent='flex-end' display={'flex'}>
				<Button disableElevation disableFocusRipple disableRipple disableTouchRipple variant='outlined' sx={{ textTransform: 'capitalize' }} onClick={handleClose}>
					{language.cancel}
				</Button>
				<Typography pl='var(--pixel16)'>
					<Button
						disableElevation
						disableFocusRipple
						disableRipple
						disableTouchRipple
						variant='contained'
						disabled={isDisabled}
						sx={{
							color         : 'var(--whiteColor)',
							textTransform : 'capitalize'
						}}
						onClick={handelPollSubmit}
					>
						{status === 'create' ? language.createPoll : language.updatePoll}
					</Button>
				</Typography>
			</Stack>
		</Grid>
	);
};

export default CreatePoll;
